import { defineMessages } from "@/i18n";
import en from "./en";

export const framesAgentListMessages = defineMessages("frames-agent-list", en);
